import { env } from '../../environments/env';

/**
 * Configuration injected by Playwright (via addInitScript) on the browser
 * window when running feature tests against a backend in the `e2e` Spring
 * profile. See docs/e2e-playwright-backendspec.md for the backend contract.
 */
export interface E2eBypassConfig {
  secret: string;
  role: string;
  user?: string;
  scenarioId?: string;
}

const E2E_BYPASS_KEY = '__E2E_BYPASS__';

function readInjectedConfig(): E2eBypassConfig | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const cfg = (window as unknown as Record<string, unknown>)[E2E_BYPASS_KEY] as E2eBypassConfig | undefined;
  if (!cfg || typeof cfg.secret !== 'string' || !cfg.secret || typeof cfg.role !== 'string' || !cfg.role) {
    return null;
  }
  return cfg;
}

function isLocalHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * Returns true only when ALL of the following hold:
 *  1. the app is NOT a production build (`env.get().production === false`), and
 *  2. it is served from localhost / 127.0.0.1, and
 *  3. Playwright injected a valid bypass config on the window.
 *
 * This triple gate guarantees the bypass can never activate in a real
 * deployment, even though the code ships in the bundle.
 */
export function isE2eBypassEnabled(): boolean {
  if (env.get().production) {
    return false;
  }
  if (!isLocalHost()) {
    return false;
  }
  return readInjectedConfig() !== null;
}

export function getE2eBypassConfig(): E2eBypassConfig | null {
  if (!isE2eBypassEnabled()) {
    return null;
  }
  return readInjectedConfig();
}
